import { useMutation, useQuery, useQueryClient } from "react-query"
import minigridAPI from "../../service/minigridAPI"
import { Minigrid } from "../../types/minigridtypes"
import { FileDtoIn } from "../../../../common/types/files.types"


export type CallbackFunction = (result:{result?: any, error?:any}) => void

/**
 * useSingleMinigridConfig
 * - minigridId : string - the id of the minigrid to get
 */
export interface useSingleMinigridConfig{
    minigridId : string
}

/**
 * useSingleMinigridCore
 * 
 * Manage the core logic for the useSingleMinigrid hook
 * 
 * - Get a single minigrid by id
 * - Update a single minigrid by id
 * - Delete a single minigrid by id
 * 
 * @param config 
 * @returns 
 */
export default function useSingleMinigirdCore(config : useSingleMinigridConfig) {

 const singleMinigridQuery = useQuery({

    queryKey : ['minigrid', config.minigridId],
    queryFn : () => minigridAPI.getSingleMinigrid(config.minigridId),
    enabled: config.minigridId !== "",
 })


 const queryClient = useQueryClient()

const updateMinigrid = useMutation({
    mutationFn : ({minigridId, minigrid, files, callbacKFunc}:{minigridId: string, files?: FileDtoIn[], minigrid: Minigrid, callbacKFunc?: CallbackFunction }) => minigridAPI.updateMinigrid(minigridId,files, minigrid).then(
        (result) => {
            if (callbacKFunc) {
                callbacKFunc({result, error: undefined})
            }
        }
    ).catch(
        (error) => {
            if (callbacKFunc) {
                callbacKFunc({result: undefined, error})
            }
            return Promise.reject(error)
        }
    ),
    onSettled : () => {
        singleMinigridQuery.refetch()
    }
})

const deleteMinigrid = useMutation({
    mutationFn: ({callbackFunc}:{ callbackFunc?:CallbackFunction}) => minigridAPI.deleteMinigrid(singleMinigridQuery.data?.minigrid_id || ""),
    onSettled: () => {
        queryClient.invalidateQueries('minigrid')
    }
})



  return {
    singleMinigridQuery : {
        data : singleMinigridQuery.data,
        isLoading : singleMinigridQuery.isLoading,
        isSuccess : singleMinigridQuery.isSuccess,
        isError : singleMinigridQuery.isError,
        error : singleMinigridQuery.error
    },
    updateMinigrid : {
        isLoading : updateMinigrid.isLoading,
        isSuccess : updateMinigrid.isSuccess,
        isError : updateMinigrid.isError,
        error : updateMinigrid.error,
        mutate : updateMinigrid.mutate
    },

    deleteMinigrid : {
        isLoading : deleteMinigrid.isLoading,
        isSuccess : deleteMinigrid.isSuccess,
        isError : deleteMinigrid.isError,
        error : deleteMinigrid.error,
        mutate : deleteMinigrid.mutate
    }


  }

  
}
